/**
 * Implementation note:
 *
 * Keep this file in-sync with corresponding mock under /test/__mocks__/@/config/
 * Keep this file in-sync with corresponding type in vite-env.d.ts
 */

const ENVIRONMENT_VALUES = {
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
  appVersion: import.meta.env.PACKAGE_VERSION,
  apiUrl: import.meta.env.VITE_API_URL,
  powerBiConfigs: {
    ctid: import.meta.env.VITE_POWERBI_CTID,
    defaultReportID: import.meta.env.VITE_POWERBI_DEFAULT_REPORT_ID,
  },
  pusherConfigs: {
    appKey: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
  },
  mapTilesConfigs: {
    tilesUrl: import.meta.env.VITE_MAP_TILES_URL,
    tilesSize: import.meta.env.VITE_MAP_TILES_SIZE,
    tilesMaxZoom: import.meta.env.VITE_MAP_TILES_MAX_ZOOM,
    tilesMinZoom: import.meta.env.VITE_MAP_TILES_MIN_ZOOM,
    tilesTopRightCoordinates: import.meta.env
      .VITE_MAP_TILES_TOP_RIGHT_COORDINATES,
    tilesBottomLeftCoordinates: import.meta.env
      .VITE_MAP_TILES_BOTTOM_LEFT_COORDINATES,
  },
  googleAnalytics: {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
  },
  googleMaps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
  },
  apiDocumentationUrl: import.meta.env.VITE_API_DOC_URL,

  // DEV TOOLS
  devTools: import.meta.env.VITE_DEV_TOOLS,
  queryDevTools: import.meta.env.VITE_QUERY_DEV_TOOLS,
  stateDevTools: import.meta.env.VITE_STATE_DEV_TOOLS,
  debugMode: import.meta.env.VITE_DEBUG_MODE,
  debugE2E: import.meta.env.VITE_E2E_DEBUG_MODE,

  // FEATURE_FLAG
  defectSuggestions: import.meta.env.VITE_FEATURE_FLAG_DEFECT_SUGGESTION,
  defectSuggestionsDecisionTool: import.meta.env
    .VITE_FEATURE_FLAG_DEFECT_SUGGESTION_DECISION_TOOL,
  dev2579: import.meta.env.VITE_FEATURE_FLAG_DEV_2579,
  dev34: import.meta.env.VITE_FEATURE_FLAG_DEV_34,
  showApiDocumentationLink: import.meta.env.VITE_FEATURE_FLAG_API_DOC_LINK,
  timeline: import.meta.env.VITE_FEATURE_FLAG_TIMELINE,
  batchUpdateObservationSeverity: import.meta.env
    .VITE_FEATURE_FLAG_BATCH_UPDATE_OBSERVATION_SEVERITY,
};

export type EnvironmentKeys = keyof typeof ENVIRONMENT_VALUES;

export const getEnvironmentValues = () => ENVIRONMENT_VALUES;

export type FeatureFlagId = Extract<
  EnvironmentKeys,
  | "defectSuggestions"
  | "defectSuggestionsDecisionTool"
  | "dev2579"
  | "dev34"
  | "showApiDocumentationLink"
  | "timeline"
  | "modulesV1"
  | "batchUpdateObservationSeverity"
>;
